import { ArrowBack } from '@mui/icons-material'
import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './_storypage.scss'
import revogasImage from '../../assets/img/revospid_promo_app.png'

import { ReactComponent as IconUtilities } from '../../assets/new-icons/utilities.svg'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
function StoryPage() {
    const navigate = useNavigate()
    const [name, setName] = useState()
    const [mail, setMail] = useState()
    const [checkBox, setCheckBox] = useState(false)
    const handleCheck = () => {
        if(checkBox && name && mail){
            alert('ok')
            
        } else {
            alert('no')
        }
    }
    const buttonRef = useRef(null)
    const exeScroll = () => buttonRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
  return (
    <div className="storyPage">
        <div className="container both-scroll both-mandatory">
            <div className="main element">
                <header>
                    <ArrowBack onClick={() => navigate(-1)}/>
                </header>
                <div className="image">
                    <img src={revogasImage} alt="" />
                </div>
                <div className="text">
                    <p className="title">
                        RevoSPID: la tua Identità Digitale con Revoluce.
                    </p>
                    <p className="para">
                        Con Revoluce attivi il Sistema Pubblico di Indentità Digital (SPID) comodamente da casa. 
                        Potrai gestire in completa autonomia tutti i tuoi rapporti con la Pubblica Amministrazione Italianna in semplicità ed autonomia.
                    </p>
                    <button onClick={exeScroll}>Scopri di più <ArrowDropDownIcon/></button>
                </div>
            </div>
            <div className="info element" ref={buttonRef}>
                <p className="title">
                    Un'esclusiva per i clienti Revoluce
                </p>
                <p className="para">
                    SPID è l’acronimo di Sistema Pubblico d’Identità Digitale e rappresenta lo strumento gratuito per semplificare l’uso dei servizi on-line per cittadino e imprese.
                </p>
                <p className="para">
                Lo SPID è la tua chiave d’accesso per i rapporti con la pubblica amministrazione, le scuole, l’INPS, la sanità e molto altro!
                </p>
                <p className="para">
                Con Revoluce lo ottieni in pochi minuti, senza bisogno di file ad uno sportello fisico perché la richiesta è completamente on-line.                </p>
            </div>
            <div className="info icone element">
                <div className="infoBlock">
                    <div className="icon">
                        <IconUtilities/>
                    </div>
                    <p className="title">
                        Identità Digitale in pochi minuti
                    </p>
                    <p className="para">
                        La procedura è completamente on-line, senza bisogno di file allo sportello. Un nostro Tutor ti guiderà in videochiamata passo passo.
                    </p>
                </div>
                <div className="infoBlock">
                    <div className="icon">
                        <IconUtilities/>
                    </div>
                    <p className="title">
                        Identità Digitale in pochi minuti
                    </p>
                    <p className="para">
                        La procedura è completamente on-line, senza bisogno di file allo sportello. Un nostro Tutor ti guiderà in videochiamata passo passo.
                    </p>
                </div>
            </div>
            <div className="info icone element">
                <div className="infoBlock">
                    <div className="icon">
                        <IconUtilities/>
                    </div>
                    <p className="title">
                        Identità Digitale in pochi minuti
                    </p>
                    <p className="para">
                        La procedura è completamente on-line, senza bisogno di file allo sportello. Un nostro Tutor ti guiderà in videochiamata passo passo.
                    </p>
                </div>
                <div className="infoBlock">
                    <div className="icon">
                        <IconUtilities/>
                    </div>
                    <p className="title">
                        Identità Digitale in pochi minuti
                    </p>
                    <p className="para">
                        La procedura è completamente on-line, senza bisogno di file allo sportello. Un nostro Tutor ti guiderà in videochiamata passo passo.
                    </p>
                </div>
            </div>
            <div className="mainPrice element">
                <div className="mainPrice-block">
                    <p className="title">Andiamo al sodo, parliamo del prezzo:</p>
                    <p className="title"><span className='ani'>Gratis</span>  se lo attivi insieme a RevoPEC</p>
                    <div className="mainPrice-info">
                        <p className='bold'>Lo SPID di Revoluce prevede un costo di attivazione di 5 €.</p>
                        <p>Il costo verrà <span className="bold">completamente eliminato</span> se <span className="bold red">attivi anche una PEC con Revoluce</span> insieme allo SPID.</p>
                        <p>Per info sull'attivazione di un indirizzo PEC con Revoluce <span className="red">clicca qui.</span></p>

                    </div>
                </div>
            </div>
            <div className="element last">
                <p className="title">Vuoi attivare RevoSPID?</p>
                <p className="para">Iniziamo! <br/> Compila il form e riceverai via e-mail le istruzioni per procedere all’attivazione. Potrai prenotare un appuntamento con un nostro Tutor per concordare la data e l’ora della videochiamata per il riconoscimento.</p>
                <p className="para">Riceverai immediatamente una mail con la procedura guidata da seguire passo passo e tutte le informazioni da comunicare al Tutor che ti aiuterà nella procedura.</p>
                <div className="formWrapper">
                    <p className="title">Richiedi più info</p>
                    <input type="text" value={name} placeholder='Il tuo nome' onChange={(e) => setName(e.target.value)}/>
                    <input type="email" value={mail} placeholder='Il tuo indirizzo mail' onChange={(e) => setMail(e.target.value)}/>
                    <div className="check">
                        <input type="checkbox" name="check" id="check" checked={checkBox} onClick={() => setCheckBox(!checkBox)}/>
                        <label htmlFor="check">Accetto il trattamento dei dati personali nel rispetto <span className="red">dell'informativa Privacy</span> ai sensi dell'art. 13 del Regolamento UE 679/2016 ("GDPR")</label>
                    </div>
                    <button onClick={() => handleCheck()}>Ricontattami</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default StoryPage